import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { MaterialUIControllerProvider } from "context";
import {Provider} from 'react-redux';
import store from './redux/Store';

ReactDOM.render(
  <React.StrictMode>
  
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <Provider store={store}>
      <App />
      </Provider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

